import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import RotateLeft from 'react-icons/lib/fa/rotate-left';

const style = {
  color: '#476166',
  margin: '0px 0px 10px 0px',
};
class ProjectFormGroupTitle extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick(this.props.forField);
    }
  }
  render() {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 style={style}>{this.props.children}</h4>
        {this.props.showIcon && (
          <RotateLeft style={{ color: '#476166', cursor: 'pointer' }} onClick={this.onClick} />
        )}
      </div>
    );
  }
}

ProjectFormGroupTitle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  forField: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(String)]).isRequired,
  showIcon: PropTypes.bool,
};

ProjectFormGroupTitle.defaultProps = {
  children: null,
  onClick: null,
  showIcon: true,
};

export default Radium(ProjectFormGroupTitle);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectForm/ProjectFormGroupTitle.js